import Api from "./tagApi";
import { createEmptyTagCard } from "../tagObjects";
import { combineNationalDataForBarCharts, calculateTopEightBarCharts, combineFilters } from "./modulesCommon";
import { combineAndCommit, clone } from "../helpers";

// TYPES
// patient data tab
const PATIENT_COMORBIDITIES = "PATIENT_COMORBIDITIES";

// cases data tab
const INTERVENTION_TONSILLECTOMY = "INTERVENTION_TONSILLECTOMY";
const INTERVENTION_ADENOIDECTOMY = "INTERVENTION_ADENOIDECTOMY";
const INTERVENTION_GROMMET_SURGERY = "INTERVENTION_GROMMET_SURGERY";

// grommets data tab
// pre-op assessment sub-tab
const GROMMETS_PRE_OP_ASSESSMENT_HEARING_ASSESSMENT = "GROMMETS_PRE_OP_ASSESSMENT_HEARING_ASSESSMENT";
const GROMMETS_PRE_OP_ASSESSMENT_INDICATION = "GROMMETS_PRE_OP_ASSESSMENT_INDICATION";
const GROMMETS_PRE_OP_ASSESSMENT_OTITITS_MEDIA_HISTORY_ASSESSMENT = "GROMMETS_PRE_OP_ASSESSMENT_OTITITS_MEDIA_HISTORY_ASSESSMENT";

// grommets data tab
// surgery assessment sub-tab
const GROMMETS_SURGERY_GROMMET_SIDES = "GROMMETS_SURGERY_GROMMET_SIDES";
const GROMMETS_SURGERY_FIRST_GROMMET_INSERTION = "GROMMETS_SURGERY_FIRST_GROMMET_INSERTION";
const GROMMETS_SURGERY_FIRST_GROMMET_TYPE = "GROMMETS_SURGERY_FIRST_GROMMET_TYPE";
const GROMMETS_SURGERY_ADENOIDECTOMY_DONE_BEFORE = "GROMMETS_SURGERY_ADENOIDECTOMY_DONE_BEFORE";
const GROMMETS_SURGERY_ADENOIDECTOMY_DONE_THIS_TIME = "GROMMETS_SURGERY_ADENOIDECTOMY_DONE_THIS_TIME";
const GROMMETS_SURGERY_EARDROPS_INTRA_OPERATIVELY = "GROMMETS_SURGERY_EARDROPS_INTRA_OPERATIVELY";
const GROMMETS_SURGERY_EARDROPS_POST_SURGERY = "GROMMETS_SURGERY_EARDROPS_POST_SURGERY";

// grommets data tab
// post-op review sub-tab
const GROMMETS_POST_OP_REVIEW_POST_OP_APPOINTMENT_TELEHEALTH = "GROMMETS_POST_OP_REVIEW_POST_OP_APPOINTMENT_TELEHEALTH";
const GROMMETS_POST_OP_REVIEW_POST_OP_APPOINTMENT_TIME_AFTER_SURGERY = "GROMMETS_POST_OP_REVIEW_POST_OP_APPOINTMENT_TIME_AFTER_SURGERY";
const GROMMETS_POST_OP_REVIEW_IN_SITU_PATENT_RIGHT_EAR = "GROMMETS_POST_OP_REVIEW_IN_SITU_PATENT_RIGHT_EAR";
const GROMMETS_POST_OP_REVIEW_IN_SITU_PATENT_LEFT_EAR = "GROMMETS_POST_OP_REVIEW_IN_SITU_PATENT_LEFT_EAR";
const GROMMETS_POST_OP_REVIEW_HEARING_ASSESSMENT_ASSESSMENT_AFTER_INDICATION = "GROMMETS_POST_OP_REVIEW_HEARING_ASSESSMENT_ASSESSMENT_AFTER_INDICATION";
const GROMMETS_POST_OP_REVIEW_HEARING_ASSESSMENT_AUDIOGRAM_IMPROVEMENT = "GROMMETS_POST_OP_REVIEW_HEARING_ASSESSMENT_AUDIOGRAM_IMPROVEMENT";
const GROMMETS_POST_OP_REVIEW_OTORRHEA = "GROMMETS_POST_OP_REVIEW_OTORRHEA";

// tonsil and adenoid data tab
// pre-op assessment sub-tab
const TONSIL_ADENOID_PRE_OP_ASSESSMENT_MAIN_INDICATION = "TONSIL_ADENOID_PRE_OP_ASSESSMENT_MAIN_INDICATION";
const TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_STUDY_PERFORMED = "TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_STUDY_PERFORMED";
const TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_AHI_PATIENT_OVER_16 = "TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_AHI_PATIENT_OVER_16";
const TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_AHI_PATIENT_UNDER_16 = "TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_AHI_PATIENT_UNDER_16";

// tonsil and adenoid data tab
// surgery assessment sub-tab
const TONSIL_ADENOID_SURGERY_TYPE_OF_STAY = "TONSIL_ADENOID_SURGERY_TYPE_OF_STAY";
const TONSIL_ADENOID_SURGERY_TYPE_OF_SURGERY = "TONSIL_ADENOID_SURGERY_TYPE_OF_SURGERY";
const TONSIL_ADENOID_SURGERY_PROCEDURE = "TONSIL_ADENOID_SURGERY_PROCEDURE";
const TONSIL_ADENOID_SURGERY_SURGICAL_TECHNIQUE = "TONSIL_ADENOID_SURGERY_SURGICAL_TECHNIQUE";
const TONSIL_ADENOID_SURGERY_PAINKILLER_PRESCRIBED = "TONSIL_ADENOID_SURGERY_PAINKILLER_PRESCRIBED";
const TONSIL_ADENOID_SURGERY_ANTIBIOTICS_PRESCRIBED = "TONSIL_ADENOID_SURGERY_ANTIBIOTICS_PRESCRIBED";
const TONSIL_ADENOID_SURGERY_SURGERY_OUTCOME = "TONSIL_ADENOID_SURGERY_SURGERY_OUTCOME";
const TONSIL_ADENOID_SURGERY_FOLLOWUP_VISIT = "TONSIL_ADENOID_SURGERY_FOLLOWUP_VISIT";
const TONSIL_ADENOID_SURGERY_LOCAL_ANAESTHETIC = "TONSIL_ADENOID_SURGERY_LOCAL_ANAESTHETIC";
const TONSIL_ADENOID_SURGERY_HAEMOSTASIS_TECHNIQUE = "TONSIL_ADENOID_SURGERY_HAEMOSTASIS_TECHNIQUE";
const TONSIL_ADENOID_SURGERY_HAEMOSTASIS_COLD_TECHNIQUE = "TONSIL_ADENOID_SURGERY_HAEMOSTASIS_COLD_TECHNIQUE";
const TONSIL_ADENOID_SURGERY_HAEMOSTASIS_HOT_TECHNIQUE = "TONSIL_ADENOID_SURGERY_HAEMOSTASIS_HOT_TECHNIQUE";

// tonsil and adenoid data tab
// post-op review sub-tab
const TONSIL_ADENOID_POST_OP_REVIEW_EAT_REGULAR_FOOD = "TONSIL_ADENOID_POST_OP_REVIEW_EAT_REGULAR_FOOD";
const TONSIL_ADENOID_POST_OP_REVIEW_PAIN_FREE = "TONSIL_ADENOID_POST_OP_REVIEW_PAIN_FREE";
const TONSIL_ADENOID_POST_OP_REVIEW_BLOOD_TRANSFUSION = "TONSIL_ADENOID_POST_OP_REVIEW_BLOOD_TRANSFUSION";
const TONSIL_ADENOID_POST_OP_REVIEW_POST_OP_APPOINTMENT_TELEHEALTH = "TONSIL_ADENOID_POST_OP_REVIEW_POST_OP_APPOINTMENT_TELEHEALTH";
const TONSIL_ADENOID_POST_OP_REVIEW_POST_OP_APPOINTMENT_TIME_AFTER_SURGERY = "TONSIL_ADENOID_POST_OP_REVIEW_POST_OP_APPOINTMENT_TIME_AFTER_SURGERY";
const TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING = "TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING";
const TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING_MAIN_QUESTION = "TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING_MAIN_QUESTION";
const TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING_SUBQUESTION = "TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING_SUBQUESTION";

// other
const DATA = "DATA";
const DATA_LOADED = "DATA_LOADED";
const DATA_LOADING = "DATA_LOADING";
const NATIONAL_DATA = "NATIONAL_DATA";
const NATIONAL_DATA_LOADED = "NATIONAL_DATA_LOADED";
const MR_ATTRIBUTES = "MR_ATTRIBUTES";

const emptyDataObj = {
    patientDemographics: {},
    patientComorbidities: {},
    patientAge: { under16Years: {}, prematurity: {} },
    caseStatistics: {},
    intervention: { tonsillectomy: {}, adenoidectomy: {}, grommetSurgery: {} },
    grommets: {
        preOpAssessment: { hearingAssessment: {}, indication: {}, otitisMediaHistoryAssessment: {} },
        surgery: {
            grommetSides: {},
            firstGrommetInsertion: {},
            grommetType: {},
            adenoidectomy: { doneBefore: {}, doneThisTime: {} },
            eardrops: { intraOperatively: {}, postSurgery: {} }
        },
        postOpReview: {
            postOpAppointment: { telehealth: {}, timeAfterSurgery: {} },
            inSituPatent: { rightEar: {}, leftEar: {} },
            hearingAssessment: { assessmentAfterIndication: {}, audiogramImprovement: {} },
            otorrhea: {}
        },
        otitisMedia6: Object.assign({}, createEmptyTagCard())
    },
    tonsilAdenoid: {
        preOpAssessment: {
            mainIndication: {},
            sleepStudy: {
                studyPerformed: {},
                ahiPatientOver16: {},
                ahiPatientUnder16: {}
            }
        },
        surgery: {
            typeOfStay: {},
            typeOfSurgery: {},
            procedure: {},
            surgicalTechnique: {},
            painkiller: {},
            antibioticsPrescribed: {},
            outcome: {},
            followUpVisit: {},
            haemostasis: {
                localAnaesthetic: {},
                coldTechnique: {},
                hotTechnique: {},
                technique: {}
            }
        },
        postOpReview: {
            eatRegularFood: {},
            painFree: {},
            bloodTransfusion: {},
            postOpAppointment: {
                telehealth: {},
                timeAfterSurgery: {}
            },
            bleeding: {
                bleeding: {},
                hospitalDueToBleeding: {
                    mainQuestion: {},
                    subQuestion: {}
                }
            }
        },
        t14Questionnaire: {
            scores: Object.assign({}, createEmptyTagCard()),
            scoresInfective: Object.assign({}, createEmptyTagCard()),
            scoresObtrusive: Object.assign({}, createEmptyTagCard())
        }
    }
};

const fields = [
    // patient data tab
    {
        commitTo: PATIENT_COMORBIDITIES,
        path: ["patientComorbidities"],
        calculateTopEight: true,
    },

    // cases data tab
    {
        commitTo: INTERVENTION_TONSILLECTOMY,
        path: ["intervention", "tonsillectomy"]
    },
    {
        commitTo: INTERVENTION_ADENOIDECTOMY,
        path: ["intervention", "adenoidectomy" ]
    },
    {
        commitTo: INTERVENTION_GROMMET_SURGERY,
        path: ["intervention", "grommetSurgery" ]
    },
    {
        commitTo: INTERVENTION_GROMMET_SURGERY,
        path: ["intervention", "grommetSurgery" ]
    },

    // grommets data tab
    // pre-op assessment sub-tab
    {
        commitTo: GROMMETS_PRE_OP_ASSESSMENT_HEARING_ASSESSMENT,
        path: ["grommets", "preOpAssessment", "hearingAssessment" ]
    },
    {
        commitTo: GROMMETS_PRE_OP_ASSESSMENT_INDICATION,
        path: ["grommets", "preOpAssessment", "indication" ]
    },
    {
        commitTo: GROMMETS_PRE_OP_ASSESSMENT_OTITITS_MEDIA_HISTORY_ASSESSMENT,
        path: ["grommets", "preOpAssessment", "otitisMediaHistoryAssessment" ]
    },

    // grommets data tab
    // surgery sub-tab
    {
        commitTo: GROMMETS_SURGERY_GROMMET_SIDES,
        path: ["grommets", "surgery", "grommetSides" ]
    },
    {
        commitTo: GROMMETS_SURGERY_FIRST_GROMMET_INSERTION,
        path: ["grommets", "surgery", "firstGrommetInsertion" ]
    },
    {
        commitTo: GROMMETS_SURGERY_FIRST_GROMMET_TYPE,
        path: ["grommets", "surgery", "grommetType" ]
    },
    {
        commitTo: GROMMETS_SURGERY_ADENOIDECTOMY_DONE_BEFORE,
        path: ["grommets", "surgery", "adenoidectomy", "doneBefore" ]
    },
    {
        commitTo: GROMMETS_SURGERY_ADENOIDECTOMY_DONE_THIS_TIME,
        path: ["grommets", "surgery", "adenoidectomy", "doneThisTime" ]
    },
    {
        commitTo: GROMMETS_SURGERY_EARDROPS_INTRA_OPERATIVELY,
        path: ["grommets", "surgery", "eardrops", "intraOperatively" ]
    },
    {
        commitTo: GROMMETS_SURGERY_EARDROPS_POST_SURGERY,
        path: ["grommets", "surgery", "eardrops", "postSurgery" ]
    },

    // grommets data tab
    // post-op review sub-tab
    {
        commitTo: GROMMETS_POST_OP_REVIEW_POST_OP_APPOINTMENT_TELEHEALTH,
        path: ["grommets", "postOpReview", "postOpAppointment", "telehealth" ]
    },
    {
        commitTo: GROMMETS_POST_OP_REVIEW_POST_OP_APPOINTMENT_TIME_AFTER_SURGERY,
        path: ["grommets", "postOpReview", "postOpAppointment", "timeAfterSurgery" ]
    },
    {
        commitTo: GROMMETS_POST_OP_REVIEW_IN_SITU_PATENT_RIGHT_EAR,
        path: ["grommets", "postOpReview", "inSituPatent", "rightEar" ]
    },
    {
        commitTo: GROMMETS_POST_OP_REVIEW_IN_SITU_PATENT_LEFT_EAR,
        path: ["grommets", "postOpReview", "inSituPatent", "leftEar" ]
    },
    {
        commitTo: GROMMETS_POST_OP_REVIEW_HEARING_ASSESSMENT_ASSESSMENT_AFTER_INDICATION,
        path: ["grommets", "postOpReview", "hearingAssessment", "assessmentAfterIndication" ]
    },
    {
        commitTo: GROMMETS_POST_OP_REVIEW_HEARING_ASSESSMENT_AUDIOGRAM_IMPROVEMENT,
        path: ["grommets", "postOpReview", "hearingAssessment", "audiogramImprovement" ]
    },
    {
        commitTo: GROMMETS_POST_OP_REVIEW_OTORRHEA,
        path: ["grommets", "postOpReview", "otorrhea" ]
    },

    // tonsils and adenoids data tab
    // pre-op assessment sub-tab
    {
        commitTo: TONSIL_ADENOID_PRE_OP_ASSESSMENT_MAIN_INDICATION,
        path: ["tonsilAdenoid", "preOpAssessment", "mainIndication" ]
    },
    {
        commitTo: TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_STUDY_PERFORMED,
        path: ["tonsilAdenoid", "preOpAssessment", "sleepStudy", "studyPerformed" ]
    },
    {
        commitTo: TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_AHI_PATIENT_OVER_16,
        path: ["tonsilAdenoid", "preOpAssessment", "sleepStudy", "ahiPatientOver16" ]
    },
    {
        commitTo: TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_AHI_PATIENT_UNDER_16,
        path: ["tonsilAdenoid", "preOpAssessment", "sleepStudy", "ahiPatientUnder16" ]
    },

    // tonsils and adenoids data tab
    // surgery sub-tab
    {
        commitTo: TONSIL_ADENOID_SURGERY_TYPE_OF_STAY,
        path: ["tonsilAdenoid", "surgery", "typeOfStay" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_TYPE_OF_SURGERY,
        path: ["tonsilAdenoid", "surgery", "typeOfSurgery" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_PROCEDURE,
        path: ["tonsilAdenoid", "surgery", "procedure" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_SURGICAL_TECHNIQUE,
        path: ["tonsilAdenoid", "surgery", "surgicalTechnique" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_PAINKILLER_PRESCRIBED,
        path: ["tonsilAdenoid", "surgery", "painkiller" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_ANTIBIOTICS_PRESCRIBED,
        path: ["tonsilAdenoid", "surgery", "antibioticsPrescribed" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_SURGERY_OUTCOME,
        path: ["tonsilAdenoid", "surgery", "outcome" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_FOLLOWUP_VISIT,
        path: ["tonsilAdenoid", "surgery", "followUpVisit" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_LOCAL_ANAESTHETIC,
        path: ["tonsilAdenoid", "surgery", "haemostasis", "localAnaesthetic" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_HAEMOSTASIS_TECHNIQUE,
        path: ["tonsilAdenoid", "surgery", "haemostasis", "technique" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_HAEMOSTASIS_COLD_TECHNIQUE,
        path: ["tonsilAdenoid", "surgery", "haemostasis", "coldTechnique" ]
    },
    {
        commitTo: TONSIL_ADENOID_SURGERY_HAEMOSTASIS_HOT_TECHNIQUE,
        path: ["tonsilAdenoid", "surgery", "haemostasis", "hotTechnique" ]
    },

    // tonsils and adenoids data tab
    // post-op review sub-tab
    {
        commitTo: TONSIL_ADENOID_POST_OP_REVIEW_EAT_REGULAR_FOOD,
        path: ["tonsilAdenoid", "postOpReview", "eatRegularFood" ]
    },
    {
        commitTo: TONSIL_ADENOID_POST_OP_REVIEW_PAIN_FREE,
        path: ["tonsilAdenoid", "postOpReview", "painFree" ]
    },
    {
        commitTo: TONSIL_ADENOID_POST_OP_REVIEW_BLOOD_TRANSFUSION,
        path: ["tonsilAdenoid", "postOpReview", "bloodTransfusion" ]
    },
    {
        commitTo: TONSIL_ADENOID_POST_OP_REVIEW_POST_OP_APPOINTMENT_TELEHEALTH,
        path: ["tonsilAdenoid", "postOpReview", "postOpAppointment", "telehealth" ]
    },
    {
        commitTo: TONSIL_ADENOID_POST_OP_REVIEW_POST_OP_APPOINTMENT_TIME_AFTER_SURGERY,
        path: ["tonsilAdenoid", "postOpReview", "postOpAppointment", "timeAfterSurgery" ]
    },
    {
        commitTo: TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING,
        path: ["tonsilAdenoid", "postOpReview", "bleeding", "bleeding" ]
    },
    {
        commitTo: TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING_MAIN_QUESTION,
        path: ["tonsilAdenoid", "postOpReview", "bleeding", "hospitalDueToBleeding", "mainQuestion" ]
    },
    {
        commitTo: TONSIL_ADENOID_POST_OP_REVIEW_BLEEDING_SUBQUESTION,
        path: ["tonsilAdenoid", "postOpReview", "bleeding", "hospitalDueToBleeding", "subQuestion" ]
    }
];

const tagDataModule = {
    namespaced: true,
    state: () => ({
        data: clone(emptyDataObj),
        dataLoaded: null,
        dataLoading: false,
        nationalData: clone(emptyDataObj),
        nationalDataLoaded: false,
        mrAttributes: Object.create({}),
    }),
    mutations: {
        // patient data tab
        [PATIENT_COMORBIDITIES](state, obj) {
            state.data.patientComorbidities = obj;
        },

        // cases data tab
        [INTERVENTION_TONSILLECTOMY](state, obj) {
            state.data.intervention.tonsillectomy = obj;
        },
        [INTERVENTION_ADENOIDECTOMY](state, obj) {
            state.data.intervention.adenoidectomy = obj;
        },
        [INTERVENTION_GROMMET_SURGERY](state, obj) {
            state.data.intervention.grommetSurgery = obj;
        },

        // grommets data tab
        // pre-op assessment sub-tab
        [GROMMETS_PRE_OP_ASSESSMENT_HEARING_ASSESSMENT](state, obj) {
            state.data.grommets.preOpAssessment.hearingAssessment = obj;
        },
        [GROMMETS_PRE_OP_ASSESSMENT_INDICATION](state, obj) {
            state.data.grommets.preOpAssessment.indication = obj;
        },
        [GROMMETS_PRE_OP_ASSESSMENT_OTITITS_MEDIA_HISTORY_ASSESSMENT](state, obj) {
            state.data.grommets.preOpAssessment.otitisMediaHistoryAssessment = obj;
        },

        // grommets data tab
        // surgery assessment sub-tab
        [GROMMETS_SURGERY_GROMMET_SIDES](state, obj) {
            state.data.grommets.surgery.grommetSides = obj;
        },
        [GROMMETS_SURGERY_FIRST_GROMMET_INSERTION](state, obj) {
            state.data.grommets.surgery.firstGrommetInsertion = obj;
        },
        [GROMMETS_SURGERY_FIRST_GROMMET_TYPE](state, obj) {
            state.data.grommets.surgery.grommetType = obj;
        },
        [GROMMETS_SURGERY_ADENOIDECTOMY_DONE_BEFORE](state, obj) {
            state.data.grommets.surgery.adenoidectomy.doneBefore = obj;
        },
        [GROMMETS_SURGERY_ADENOIDECTOMY_DONE_THIS_TIME](state, obj) {
            state.data.grommets.surgery.adenoidectomy.doneThisTime = obj;
        },
        [GROMMETS_SURGERY_EARDROPS_INTRA_OPERATIVELY](state, obj) {
            state.data.grommets.surgery.eardrops.intraOperatively = obj;
        },
        [GROMMETS_SURGERY_EARDROPS_POST_SURGERY](state, obj) {
            state.data.grommets.surgery.eardrops.postSurgery = obj;
        },

        // grommets data tab
        // post-op review sub-tab
        [GROMMETS_POST_OP_REVIEW_POST_OP_APPOINTMENT_TELEHEALTH](state, obj) {
            state.data.grommets.postOpReview.postOpAppointment.telehealth = obj;
        },
        [GROMMETS_POST_OP_REVIEW_POST_OP_APPOINTMENT_TIME_AFTER_SURGERY](state, obj) {
            state.data.grommets.postOpReview.postOpAppointment.timeAfterSurgery = obj;
        },
        [GROMMETS_POST_OP_REVIEW_IN_SITU_PATENT_RIGHT_EAR](state, obj) {
            state.data.grommets.postOpReview.inSituPatent.rightEar = obj;
        },
        [GROMMETS_POST_OP_REVIEW_IN_SITU_PATENT_LEFT_EAR](state, obj) {
            state.data.grommets.postOpReview.inSituPatent.leftEar = obj;
        },
        [GROMMETS_POST_OP_REVIEW_HEARING_ASSESSMENT_ASSESSMENT_AFTER_INDICATION](state, obj) {
            state.data.grommets.postOpReview.hearingAssessment.assessmentAfterIndication = obj;
        },
        [GROMMETS_POST_OP_REVIEW_HEARING_ASSESSMENT_AUDIOGRAM_IMPROVEMENT](state, obj) {
            state.data.grommets.postOpReview.hearingAssessment.audiogramImprovement = obj;
        },
        [GROMMETS_POST_OP_REVIEW_OTORRHEA](state, obj) {
            state.data.grommets.postOpReview.otorrhea = obj;
        },

        // tonsils and adenoid data tab
        // pre-op assessment sub-tab
        [TONSIL_ADENOID_PRE_OP_ASSESSMENT_MAIN_INDICATION](state, obj) {
            state.data.tonsilAdenoid.preOpAssessment.mainIndication = obj;
        },
        [TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_STUDY_PERFORMED](state, obj) {
            state.data.tonsilAdenoid.preOpAssessment.sleepStudy.studyPerformed = obj;
        },
        [TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_AHI_PATIENT_OVER_16](state, obj) {
            state.data.tonsilAdenoid.preOpAssessment.sleepStudy.ahiPatientOver16 = obj;
        },
        [TONSIL_ADENOID_PRE_OP_ASSESSMENT_SLEEP_AHI_PATIENT_UNDER_16](state, obj) {
            state.data.tonsilAdenoid.preOpAssessment.sleepStudy.ahiPatientUnder16 = obj;
        },

        // other
        [DATA](state, data) {
            state.data = data;
        },
        [DATA_LOADED](state, isDataLoaded) {
            state.dataLoaded = isDataLoaded;
        },
        [DATA_LOADING](state, dataLoading) {
            state.dataLoading = dataLoading;
        },
        [NATIONAL_DATA](state, obj) {
            state.nationalData = obj;
        },
        [NATIONAL_DATA_LOADED](state, isNationalDataLoaded) {
            state.nationalDataLoaded = isNationalDataLoaded;
        },
        [MR_ATTRIBUTES](state, mrAttributes) {
            state.mrAttributes = mrAttributes;
        },
    },
    actions: {
        readData({ commit, state, rootState }, context) {

            let filters = combineFilters(rootState.patientQuery, rootState.caseQuery, rootState.advancedQueryCriteria);
            commit(DATA_LOADED, false);

            return Api.GetData(context, filters)
                .then(function (result) {
                    calculateTopEightBarCharts(fields, result.data);

                    result.data.intervention = combineActualAndPlannedInterventions(result.data.intervention);

                    // if context data should be combined with national data
                    if (rootState.dataModule.system.isNationalDataNeeded)
                        combineNationalDataForBarCharts(fields, result.data, state.nationalData);

                    commit(DATA, result.data);
                    commit(DATA_LOADED, true);
                });
        },
        readNationalData({ commit, state, rootState }) {
            commit(NATIONAL_DATA_LOADED, false);
            let filters = combineFilters(rootState.patientQuery, rootState.caseQuery, rootState.advancedQueryCriteria);

            return Api.GetNationalData(filters, rootState).then(function (result) {

                result.data.intervention = combineActualAndPlannedInterventions(result.data.intervention);

                fields.forEach((element) => {

                    let statePath = state.data;
                    let resultPath = result.data;

                    for (let index = 0; index < element.path.length; index++) {
                        statePath = statePath[element.path[index]];
                        resultPath = resultPath[element.path[index]];
                    }

                    combineAndCommit(commit, element.commitTo, statePath, resultPath);
                });

                commit(NATIONAL_DATA, result.data);
                commit(NATIONAL_DATA_LOADED, true);
            });
        },
        // is data was loaded
        setDataLoaded({ commit }, isDataLoaded) {
            return commit(DATA_LOADED, isDataLoaded);
        },
        setDataLoading({ commit }, isDataLoading) {
            return commit(DATA_LOADING, isDataLoading);
        },
        cleanData({ commit }) {
            commit(DATA, clone(emptyDataObj));
            commit(DATA_LOADED, false);
        },
        readMrAttributes({ commit }) {
            return Api.GetMrAttributes().then((result) => {
                commit(MR_ATTRIBUTES, result.data);
            });
        },
    },
};

function combineActualAndPlannedInterventions(interventions) {
    let combined = {
        tonsillectomy: generateInterventions(interventions, 'Tonsillectomy'),
        adenoidectomy: generateInterventions(interventions, 'Adenoidectomy'),
        grommetSurgery: generateInterventions(interventions,  'Grommet surgery')
    };

    return combined;
};

function generateInterventions(interventions, interventionName) {
    let actual = interventions.actualInterventions.mrAttributeRowViewModelList.filter(x => x.name == interventionName)[0];
    actual.name = 'Actual intervention (surgery)';

    let planned = interventions.plannedInterventions.mrAttributeRowViewModelList.filter(x => x.name == interventionName)[0];
    planned.name = 'Planned in pre-op assessment';

    let intervention = {
        mrAttributeRowViewModelList: [],
        propertiesMaxPercent: parseInt(actual.percent) > parseInt(planned.percent) ? actual.percent : planned.percent,
        totalCount: parseInt(actual.count) + parseInt(planned.count),
    };

    intervention.mrAttributeRowViewModelList.push(actual);
    intervention.mrAttributeRowViewModelList.push(planned);

    return intervention;
};

export default tagDataModule;
